import mitt from 'mitt';

/**
 * Class to trigger global messages through the app
 */
class GlobalEventDispatcher {
  _emitter = mitt();

  register(event, listener) {
    this._emitter.on(event, listener);
  }

  unregister(event, listener) {
    this._emitter.off(event, listener);
  }

  dispatch(event, params) {
    this._emitter.emit(event, params);
  }
}
export const globalEventDispatcher = new GlobalEventDispatcher();

/**
 * Messages constants
 */
export class ShizenGlobalEvent {
  // Make the router push the default home page
  static PUSH_HOME_PAGE = 'ShizenGlobalEvent.PUSH_HOME_PAGE';

  // Open/Hide the PDCA editor
  static OPEN_PDCA = 'ShizenGlobalEvent.OPEN_PDCA';

  static HIDE_PDCA = 'ShizenGlobalEvent.HIDE_PDCA';

  static SET_PDCA_STATE = 'ShizenGlobalEvent.SET_PDCA_STATE';

  // Show charts tooltip
  static CHART_TOOLTIP_SHOW = 'ShizenGlobalEvent.CHART_TOOLTIP_SHOW';

  static CHART_TOOLTIP_HIDE = 'ShizenGlobalEvent.CHART_TOOLTIP_HIDE';

  static CHART_TOOLTIP_SET_CLICKABLE = 'ShizenGlobalEvent.CHART_TOOLTIP_SET_CLICKABLE';

  // Trigger the fullscreen editor
  static FS_EDITOR_SHOW = 'ShizenGlobalEvent.FS_EDITOR_SHOW';

  static FS_EDITOR_START_EDIT = 'ShizenGlobalEvent.FS_EDITOR_START_EDIT';

  static FS_EDITOR_HIDE = 'ShizenGlobalEvent.FS_EDITOR_HIDE';

  static FS_EDITOR_DO_FOCUS = 'ShizenGlobalEvent.FS_EDITOR_DO_FOCUS';

  // Check if a rating modal should be displayed and triggers it if required
  static ACTION_CREATED = 'ShizenGlobalEvent.ACTION_CREATED';

  static PROBLEM_REPORTED = 'ShizenGlobalEvent.PROBLEM_REPORTED';

  static GW_COMPLETED = 'ShizenGlobalEvent.GW_COMPLETED';

  static MEETING_ENDED = 'ShizenGlobalEvent.MEETING_ENDED';

  static LEAVING_MEETING_SETTINGS_AFTER_CREATION = 'ShizenGlobalEvent.LEAVING_MEETING_SETTINGS_AFTER_CREATION';

  static INFORMATION_CREATED = 'ShizenGlobalEvent.INFORMATION_CREATED';

  static INDICATOR_INPUT_EDITED = 'ShizenGlobalEvent.INDICATOR_EDITED';

  // Language update
  static SET_LANGUAGE = 'ShizenGlobalEvent.SET_LANGUAGE';

  // Create a new action/info/problem while the an edition modal is active
  static NEW_MODAL_WHILE_ONE_ACTIVE = 'ShizenGlobalEvent.NEW_MODAL_WHILE_ONE_ACTIVE';

  // Create a new action/info/problem while the an edition modal is active
  static NEW_PROBLEM = 'ShizenGlobalEvent.NEW_PROBLEM';

  // Event triggered for each new XHR
  static XHR_STARTED = 'ShizenGlobalEvent.XHR_STARTED';

  static XHR_ENDED = 'ShizenGlobalEvent.XHR_ENDED';
}


export default {
  ShizenGlobalEvent,
  globalEventDispatcher,
};
